import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { COLLECTION_IDS } from "../../../shared/config/collections.js";
import { createAppApi } from "../../../shared/lib/store/createAppApi.js";
import { PerxisService } from "../../../shared/services/perxis/index.js";
import { dataFormatter } from "../../../shared/store/config/lib/dataFormatter.js";
import { getExtendedItems } from "../../../shared/store/reference/lib/getExtendedItems.js";
import { FormatterDataTypeEnum } from "../../../shared/types/formatter.js";
import { name } from "../config/name.js";
const api = createAppApi({
  reducerPath: name,
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getSpecifications: builder.query({
      queryFn: async ({ referenceFields, ...parameters }, api2) => {
        const { itemsClient } = PerxisService.getInstance();
        const response = await itemsClient.findPublished({
          ...parameters,
          collectionId: COLLECTION_IDS.vehiclesSpecifications
        });
        const { items, total } = response;
        const extSpecificationItems = await getExtendedItems(
          api2,
          items,
          { fields: referenceFields }
        );
        const formattedExtSpecificationItems = dataFormatter(
          api2,
          FormatterDataTypeEnum.Specification,
          extSpecificationItems
        );
        return {
          data: {
            items: formattedExtSpecificationItems,
            total
          }
        };
      }
    }),
    getSpecificationGroups: builder.query({
      queryFn: async ({ referenceFields, ...parameters }, api2) => {
        const { itemsClient } = PerxisService.getInstance();
        const response = await itemsClient.findPublished({
          ...parameters,
          collectionId: COLLECTION_IDS.vehiclesSpecificationsGroups
        });
        const { items, total } = response;
        const extSpecificationGroupItems = await getExtendedItems(api2, items, { fields: referenceFields });
        const formattedExtSpecificationGroupItems = dataFormatter(
          api2,
          FormatterDataTypeEnum.SpecificationGroup,
          extSpecificationGroupItems
        );
        return {
          data: {
            items: formattedExtSpecificationGroupItems,
            total
          }
        };
      }
    }),
    getOptionGroups: builder.query({
      queryFn: async ({ referenceFields, ...parameters }, api2) => {
        const { itemsClient } = PerxisService.getInstance();
        const response = await itemsClient.findPublished({
          ...parameters,
          collectionId: COLLECTION_IDS.vehiclesOptionsGroups
        });
        const { items, total } = response;
        const extOptionGroupItems = await getExtendedItems(api2, items, {
          fields: referenceFields
        });
        const formattedExtOptionGroupItems = dataFormatter(
          api2,
          FormatterDataTypeEnum.OptionGroup,
          extOptionGroupItems
        );
        return {
          data: {
            items: formattedExtOptionGroupItems,
            total
          }
        };
      }
    })
  })
});
const {
  reducer,
  reducerPath,
  useGetOptionGroupsQuery,
  useGetSpecificationGroupsQuery,
  useGetSpecificationsQuery,
  useLazyGetOptionGroupsQuery,
  useLazyGetSpecificationGroupsQuery,
  useLazyGetSpecificationsQuery
} = api;
export {
  api,
  reducer,
  reducerPath,
  useGetOptionGroupsQuery,
  useGetSpecificationGroupsQuery,
  useGetSpecificationsQuery,
  useLazyGetOptionGroupsQuery,
  useLazyGetSpecificationGroupsQuery,
  useLazyGetSpecificationsQuery
};
